'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _AccountGuestPopup = require('./AccountGuestPopup');

var _AccountGuestPopup2 = _interopRequireDefault(_AccountGuestPopup);

var _AccountUserPopup = require('./AccountUserPopup');

var _AccountUserPopup2 = _interopRequireDefault(_AccountUserPopup);

var _navigationActions = require('../../../../reducers/navigationActions');

require('./AccountPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        currentUser: state.getIn(['app', 'currentUser'])
    };
};

// Styles


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        login: function login() {
            return dispatch((0, _navigationActions.navigateToLogin)());
        }
    };
};

var AccountPopup = function AccountPopup(props) {
    return props.currentUser.get('isGuest') ? _react2.default.createElement(_AccountGuestPopup2.default, props) : _react2.default.createElement(_AccountUserPopup2.default, props);
};

AccountPopup.propTypes = {
    currentUser: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountPopup);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/AccountPopup.js
// module id = 771
// module chunks = 0